import React from 'react';

import { useDocumentBlock, useDocumentBlockName } from '@wp-block-builder/editor/hooks';

import AvatarSidebarForm from './forms/AvatarSidebarForm';
import ButtonSidebarForm from './forms/ButtonSidebarForm';
import ColumnsSectionSidebarForm from './forms/ColumnsSectionSidebarForm';
import ContainerSidebarForm from './forms/ContainerSidebarForm';
import ContainerYieldSidebarForm from './forms/ContainerYieldSidebarForm';
import DividerSidebarForm from './forms/DividerSidebarForm';
import HeadingSidebarForm from './forms/HeadingSidebarForm';
import HtmlSidebarForm from './forms/HtmlSidebarForm';
import ImageSidebarForm from './forms/ImageSidebarForm';
import LoopContainerSidebarForm from './forms/LoopContainerSidebarForm';
import ProgressBarSidebarForm from './forms/ProgressBarSidebarForm';
import SpacerSidebarForm from './forms/SpacerSidebarForm';
import TextSidebarForm from './forms/TextSidebarForm';

type Props = {
  blockId: string;
};
export default function BlockSidebarForm({ blockId }: Props) {
  const name = useDocumentBlockName(blockId);
  const block = useDocumentBlock(blockId);
  if (!name || !block) {
    return null;
  }
  switch (block.type) {
    case 'Avatar':
      return <AvatarSidebarForm key={name} name={name} />;
    case 'Button':
      return <ButtonSidebarForm key={name} name={name} />;
    case 'ColumnsSection':
      return <ColumnsSectionSidebarForm key={name} name={name} />;
    case 'Container':
      return <ContainerSidebarForm key={name} name={name} />;
    case 'ContainerYield':
      return <ContainerYieldSidebarForm key={name} name={name} />;
    case 'Divider':
      return <DividerSidebarForm key={name} name={name} />;
    case 'Heading':
      return <HeadingSidebarForm key={name} name={name} />;
    case 'Html':
      return <HtmlSidebarForm key={name} name={name} />;
    case 'Image':
      return <ImageSidebarForm key={name} name={name} />;
    case 'LoopContainer':
      return <LoopContainerSidebarForm key={name} name={name} />;
    case 'ProgressBar':
      return <ProgressBarSidebarForm key={name} name={name} />;
    case 'Spacer':
      return <SpacerSidebarForm key={name} name={name} />;
    case 'Text':
      return <TextSidebarForm key={name} name={name} />;
  }
}
